import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    // Scroll to top unless there's a hash (e.g. #section)
    if (hash === "") {
      window.scrollTo(0, 0);
    } else {
      // Scroll to the element with the ID matching the hash
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [pathname, hash, key]);

  return null;
}
